import { ComponentType } from "react"
import {
  Building02,
  CoinsHand,
  Compass03,
  // TODO: import `Percent2` after merging the PR in Clay lib.
  Cube01 as Percent2,
  HomeSmile,
  IconProps,
  Lightning01,
  ReceiptCheck,
  Safe,
  Trophy02Outline,
} from "@mezo-org/mezo-clay"

import {
  ENABLE_EXPLORE_PAGE,
  ENABLE_GOVERNANCE_PAGE,
  ENABLE_VAULT_PAGE,
} from "./feature-flag"
import { IS_MEZO_MAINNET } from "./network"
import { routes } from "./routes"

export type SidebarNavigationItemProps = {
  navigationTitle: string
  pageTitle: string
  route: string
  Icon: ComponentType<IconProps>
  posthogDataAttribute: string
  isMatsnetRoute?: boolean
}

export const MAINNET_NAVIGATION_ITEMS: SidebarNavigationItemProps[] = [
  ...(ENABLE_EXPLORE_PAGE
    ? [
        {
          navigationTitle: "Explore",
          pageTitle: "Explore",
          route: routes.EXPLORE,
          Icon: Compass03,
          posthogDataAttribute: "sidebar-explore",
        },
      ]
    : []),
]

export const NAVIGATION_ITEMS: SidebarNavigationItemProps[] = [
  {
    navigationTitle: "Home",
    pageTitle: "Home",
    route: routes.HOME,
    Icon: HomeSmile,
    posthogDataAttribute: "sidebar-home",
  },
  {
    navigationTitle: "Borrow",
    pageTitle: "Borrow",
    route: routes.BORROW,
    Icon: CoinsHand,
    posthogDataAttribute: "sidebar-borrow_cta",
    isMatsnetRoute: !IS_MEZO_MAINNET,
  },
  {
    navigationTitle: "Market",
    pageTitle: "Market",
    route: routes.STORE,
    Icon: Building02,
    posthogDataAttribute: "sidebar-market_cta",
    isMatsnetRoute: !IS_MEZO_MAINNET,
  },
  {
    navigationTitle: "mats",
    pageTitle: "mats",
    route: routes.MATS,
    Icon: Lightning01,
    posthogDataAttribute: "sidebar-mats",
  },
  {
    navigationTitle: "Deposit",
    pageTitle: "Deposit",
    route: routes.DEPOSIT,
    Icon: ReceiptCheck,
    posthogDataAttribute: "sidebar-deposit",
  },
  ...(ENABLE_GOVERNANCE_PAGE
    ? [
        {
          navigationTitle: "Earn",
          pageTitle: "Earn",
          route: routes.EARN,
          Icon: Percent2,
          isMatsnetRoute: !IS_MEZO_MAINNET,
          posthogDataAttribute: "sidebar-earn",
        },
      ]
    : []),
  ...(ENABLE_VAULT_PAGE
    ? [
        {
          navigationTitle: "Vault",
          pageTitle: "Vault",
          route: routes.VAULT,
          Icon: Safe,
          posthogDataAttribute: "sidebar-vault",
        },
      ]
    : []),
  {
    navigationTitle: IS_MEZO_MAINNET ? "Leaderboard" : "Leaderboards",
    pageTitle: IS_MEZO_MAINNET ? "Leaderboard" : "Leaderboards",
    route: routes.LEADERBOARD,
    Icon: Trophy02Outline,
    posthogDataAttribute: "sidebar-leaderboard",
  },
  ...(IS_MEZO_MAINNET ? MAINNET_NAVIGATION_ITEMS : []),
]

export const SIDEBAR_NAVIGATION_WIDTH = "220px"
